import React, { Component, Fragment } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './TelemetryService';
import { withRouter, RouteComponentProps } from 'react-router-dom';

/**
 * This Component provides telemetry with Azure App Insights
 *
 * NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component
 */

interface OwnProps {
    instrumentationKey: string;
    children: React.ReactNode;
}

type TelemetryProviderProps = OwnProps & RouteComponentProps<{}>;

class TelemetryProvider extends Component<TelemetryProviderProps> {
    state = {
        initialized: false
    };

    componentDidMount(): void {
        const { history } = this.props;
        const { initialized } = this.state;
        const AppInsightsInstrumentationKey = this.props.instrumentationKey;
        if (!Boolean(initialized) && Boolean(AppInsightsInstrumentationKey) && Boolean(history)) {
            ai.initialize(AppInsightsInstrumentationKey, history);
            this.setState({ initialized: true });
        }
    }

    render(): JSX.Element {
        const { children } = this.props;
        return <Fragment>{children}</Fragment>;
    }
}

export default withRouter(withAITracking(ai.reactPlugin, TelemetryProvider));



// WEBPACK FOOTER //
// ./src/providers/TelemetryProvider.tsx